/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompetitionLeagueCreate,
  CompetitionLeagueRead,
  CompetitionLeagueUpdate,
  HTTPValidationError,
} from '../models/index';
import {
    CompetitionLeagueCreateFromJSON,
    CompetitionLeagueCreateToJSON,
    CompetitionLeagueReadFromJSON,
    CompetitionLeagueReadToJSON,
    CompetitionLeagueUpdateFromJSON,
    CompetitionLeagueUpdateToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface CreateCompetitionLeagueRequest {
    competitionLeagueCreate: CompetitionLeagueCreate;
}

export interface DeleteCompetitionLeagueRequest {
    competitionLeagueId: string;
}

export interface GetCompetitionLeagueRequest {
    competitionLeagueId: string;
}

export interface UpdateCompetitionLeagueRequest {
    competitionLeagueId: string;
    competitionLeagueUpdate: CompetitionLeagueUpdate;
}

/**
 * 
 */
export class CompetitionLeaguesApi extends runtime.BaseAPI {

    /**
     * Create a new competition league.  Competition leagues are platform-wide entities that categorize competitions. Only superadmins can create leagues as they are shared across all organizations.
     * Create Competition League
     */
    async createCompetitionLeagueRaw(requestParameters: CreateCompetitionLeagueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitionLeagueRead>> {
        if (requestParameters['competitionLeagueCreate'] == null) {
            throw new runtime.RequiredError(
                'competitionLeagueCreate',
                'Required parameter "competitionLeagueCreate" was null or undefined when calling createCompetitionLeague().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competition_leagues/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompetitionLeagueCreateToJSON(requestParameters['competitionLeagueCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitionLeagueReadFromJSON(jsonValue));
    }

    /**
     * Create a new competition league.  Competition leagues are platform-wide entities that categorize competitions. Only superadmins can create leagues as they are shared across all organizations.
     * Create Competition League
     */
    async createCompetitionLeague(requestParameters: CreateCompetitionLeagueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitionLeagueRead> {
        const response = await this.createCompetitionLeagueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a competition league.  Only superadmins can delete leagues as they are shared across all organizations. While the league still has seasons the delete is refused with 409 and the league stays; delete its seasons or move them to another league first. Competitions are never deleted: those linked to the league keep existing without a league.
     * Delete Competition League
     */
    async deleteCompetitionLeagueRaw(requestParameters: DeleteCompetitionLeagueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['competitionLeagueId'] == null) {
            throw new runtime.RequiredError(
                'competitionLeagueId',
                'Required parameter "competitionLeagueId" was null or undefined when calling deleteCompetitionLeague().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competition_leagues/{competition_league_id}`.replace(`{${"competition_league_id"}}`, encodeURIComponent(String(requestParameters['competitionLeagueId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a competition league.  Only superadmins can delete leagues as they are shared across all organizations. While the league still has seasons the delete is refused with 409 and the league stays; delete its seasons or move them to another league first. Competitions are never deleted: those linked to the league keep existing without a league.
     * Delete Competition League
     */
    async deleteCompetitionLeague(requestParameters: DeleteCompetitionLeagueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCompetitionLeagueRaw(requestParameters, initOverrides);
    }

    /**
     * Get a competition league by ID. Requires authentication.
     * Get Competition League
     */
    async getCompetitionLeagueRaw(requestParameters: GetCompetitionLeagueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitionLeagueRead>> {
        if (requestParameters['competitionLeagueId'] == null) {
            throw new runtime.RequiredError(
                'competitionLeagueId',
                'Required parameter "competitionLeagueId" was null or undefined when calling getCompetitionLeague().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competition_leagues/{competition_league_id}`.replace(`{${"competition_league_id"}}`, encodeURIComponent(String(requestParameters['competitionLeagueId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitionLeagueReadFromJSON(jsonValue));
    }

    /**
     * Get a competition league by ID. Requires authentication.
     * Get Competition League
     */
    async getCompetitionLeague(requestParameters: GetCompetitionLeagueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitionLeagueRead> {
        const response = await this.getCompetitionLeagueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all competition leagues. Requires authentication.
     * Get Competition Leagues
     */
    async getCompetitionLeaguesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompetitionLeagueRead>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competition_leagues/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompetitionLeagueReadFromJSON));
    }

    /**
     * Get all competition leagues. Requires authentication.
     * Get Competition Leagues
     */
    async getCompetitionLeagues(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompetitionLeagueRead>> {
        const response = await this.getCompetitionLeaguesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update a competition league.  Only superadmins can update leagues as they are shared across all organizations.
     * Update Competition League
     */
    async updateCompetitionLeagueRaw(requestParameters: UpdateCompetitionLeagueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitionLeagueRead>> {
        if (requestParameters['competitionLeagueId'] == null) {
            throw new runtime.RequiredError(
                'competitionLeagueId',
                'Required parameter "competitionLeagueId" was null or undefined when calling updateCompetitionLeague().'
            );
        }

        if (requestParameters['competitionLeagueUpdate'] == null) {
            throw new runtime.RequiredError(
                'competitionLeagueUpdate',
                'Required parameter "competitionLeagueUpdate" was null or undefined when calling updateCompetitionLeague().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/competition_leagues/{competition_league_id}`.replace(`{${"competition_league_id"}}`, encodeURIComponent(String(requestParameters['competitionLeagueId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CompetitionLeagueUpdateToJSON(requestParameters['competitionLeagueUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitionLeagueReadFromJSON(jsonValue));
    }

    /**
     * Update a competition league.  Only superadmins can update leagues as they are shared across all organizations.
     * Update Competition League
     */
    async updateCompetitionLeague(requestParameters: UpdateCompetitionLeagueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitionLeagueRead> {
        const response = await this.updateCompetitionLeagueRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
